// extracted by mini-css-extract-plugin
export default {"carousel":"LocationSection_carousel__KxkK8","location":"LocationSection_location__esy03"};